module.exports = __webpack_public_path__ + "img/v4_assetReport.f8350e68.png";